<template>
  <div class="modal-component" v-if="show">
    <div class="modal" ref="modal">
      <span class="close-btn" @click="close">×</span>
      <h3 class="title">{{ title }}</h3>
      <div class="modal-body">
        <slot/>
      </div>
      <div class="modal-foot">
        <span class="confirm-btn-container">
          <Button
            style="height: 35px;line-height: 35px;width: 105px;"
            type="danger"
            :text="text"
            :onClick="handleClickConfirm"
          />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Button from '@/components/Button/index.vue'

export default {
  name: 'c-modal',
  props: {
    text: {
      type: String,
      default: '确定'
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    onOk: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      show: this.visible
    }
  },
  methods: {
    hide() {
      this.$refs.modal.className = this.$refs.modal.className + 'modal-hidden'
    },
    close () {
      this.$emit('update:visible', false)
      this.hide()
    },
    handleClickConfirm() {
      this.onOk()
      this.close()
    }
  },
  components: { Button },
  watch: {
    visible(v) {
      this.show = v
    }
  }
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
